import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    subscriptionExpired: false,
};
export const subscriptionExpiredSlice = createSlice({
    name: "subscriptionExpired",
    initialState,
    reducers: {
        setSubscriptionExpired: (state, action) => {
            state.subscriptionExpired = action.payload;
    },

},
});

export const { setSubscriptionExpired } = subscriptionExpiredSlice.actions;
export default subscriptionExpiredSlice.reducer;
